import { createSlice } from '@reduxjs/toolkit'

import { EMPTY_FORM } from '../../containers/editSchedule/constants'
import { editSchedulePageSelectors } from '../selectors/editSchedulePage'

const initialState = {
    dateFrom: '',
    dateTo: '',
    viewMode: 'group',
    selectedGroupId: '',
    selectedTeacherId: '',
    selectedRoomId: '',
    selectedBuildId: '',
    selectedClassTypeId: '',
    selectedSubjectId: '',
    currentPage: 1,
    pageSize: 15,
    showMoreOptions: false,
    form: EMPTY_FORM,
    initialForm: EMPTY_FORM,
    editingId: null,
    isCreating: false,
    showDeleteModal: false,
    deleteClassId: null,
    showCloseEditorModal: false,
    pendingAction: null,
}

const editSchedulePage = createSlice({
    name: 'editSchedulePage',
    initialState,
    reducers: {
        setDateRange: (state, action) => {
            state.dateFrom = action.payload.dateFrom
            state.dateTo = action.payload.dateTo
            state.currentPage = 1
        },
        clearDateFilter: (state) => {
            state.dateFrom = ''
            state.dateTo = ''
        },
        setViewMode: (state, action) => {
            state.viewMode = action.payload
            state.currentPage = 1
        },
        setSelectedGroupId: (state, action) => {
            state.selectedGroupId = action.payload
            state.currentPage = 1
        },
        setSelectedTeacherId: (state, action) => {
            state.selectedTeacherId = action.payload
            state.currentPage = 1
        },
        setSelectedRoomId: (state, action) => {
            state.selectedRoomId = action.payload
            state.currentPage = 1
        },
        setSelectedBuildId: (state, action) => {
            state.selectedBuildId = action.payload
            state.selectedRoomId = ''
            state.currentPage = 1
        },
        setSelectedClassTypeId: (state, action) => {
            state.selectedClassTypeId = action.payload
            state.currentPage = 1
        },
        setSelectedSubjectId: (state, action) => {
            state.selectedSubjectId = action.payload
            state.currentPage = 1
        },
        setPagination: (state, action) => {
            state.currentPage = action.payload.page
            if (action.payload.pageSize !== undefined) {
                state.pageSize = action.payload.pageSize
                state.currentPage = 1
            }
        },
        toggleShowMoreOptions: (state) => {
            state.showMoreOptions = !state.showMoreOptions
        },
        resetFilters: (state) => {
            state.selectedRoomId = ''
            state.selectedClassTypeId = ''
            state.selectedSubjectId = ''
            state.selectedBuildId = ''
        },
        setForm: (state, action) => {
            state.form = action.payload
        },
        setInitialForm: (state, action) => {
            state.initialForm = action.payload
        },
        openEditor: (state, action) => {
            state.form = action.payload.form
            state.initialForm = action.payload.initialForm
            state.editingId = action.payload.editingId
            state.isCreating = action.payload.isCreating
        },
        resetEditor: (state) => {
            state.form = EMPTY_FORM
            state.initialForm = EMPTY_FORM
            state.editingId = null
            state.isCreating = false
            state.pendingAction = null
        },
        updateFormField: (state, action) => {
            const { name, value } = action.payload
            state.form[name] = value
        },
        updateFormFields: (state, action) => {
            state.form = {
                ...state.form,
                ...action.payload,
            }
        },
        setShowDeleteModal: (state, action) => {
            state.showDeleteModal = action.payload.open
            state.deleteClassId = action.payload.classId ?? null
        },
        setShowCloseEditorModal: (state, action) => {
            state.showCloseEditorModal = action.payload.open
            if (!action.payload.open) {
                state.pendingAction = null
            }
        },
        setPendingAction: (state, action) => {
            state.pendingAction = action.payload
            state.showCloseEditorModal = true
        },
        resetPage: () => initialState,
    },
    selectors: {
        ...editSchedulePageSelectors,
    },
})

export const editSchedulePageSelector = editSchedulePage.getSelectors()
export const editSchedulePageActions = editSchedulePage.actions

export default editSchedulePage.reducer
